import { PageHeaderWrapper } from '@ant-design/pro-layout';
import styled from 'styled-components';

const PageWithHeader = styled(PageHeaderWrapper)`
    & .ant-page-header {
        padding: 18px 24px 16px;
    }

    & .ant-pro-page-container-children-content {
        margin: 0px 24px 0;
    }
`;

export default PageWithHeader;
